module.exports = __webpack_public_path__ + "img/GDP-2.bd00a88e.jpg";